import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/starter.png'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        class: "mb-4",
        alt: "starter"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h3", {
        class: "fs-4 mb-4 m-auto",
        style: {"max-width":"500px"}
      }, " Create something beautiful, like a masterpiece or a really good sandwich. ", -1)),
      _createVNode(_component_RouterLink, {
        to: "/dashboard",
        class: "btn btn-primary text-decoration-none py-2 px-3 fs-16 fw-medium"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "d-inline-block py-1" }, "Getting Started", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}